export enum NhisProvider {
  KAKAO = 'KAKAO',
  NAVER = 'NAVER',
  PASS = 'PASS',
}

export type NhisProviderType = keyof typeof NhisProvider;

export const NhisProviderTextMap: Record<NhisProvider, string> = {
  [NhisProvider.KAKAO]: '카카오',
  [NhisProvider.NAVER]: '네이버',
  [NhisProvider.PASS]: 'PASS',
};

export const NhisProviderHelpUrlMap: Record<NhisProvider, string> = {
  [NhisProvider.KAKAO]: 'https://cs.kakao.com/helps?service=179&category=660&locale=ko',
  [NhisProvider.NAVER]: 'https://help.naver.com/service/22027/category/bookmark?lang=ko',
  [NhisProvider.PASS]: '',
};
